import { Component, OnInit, Input } from '@angular/core';
import { Project } from '../../data/project/project';
import { ProjectStatus } from '../../data/project/statuses/project-status';
import { ProjectHolder } from '../../interfaces/project-holder';
import { ProjectService } from '../../data/project/project.service';

@Component({
  selector: 'app-docusign-status-edit',
  templateUrl: './docusign-status-edit.component.html',
  styleUrls: ['./docusign-status-edit.component.scss']
})
export class DocusignStatusEditComponent implements OnInit {
  project: Project;

  @Input()
  status: ProjectStatus;
  tempStatus: ProjectStatus;

  statuses: ProjectStatus[];

  constructor(
    protected projectHolder: ProjectHolder,
    private projectService: ProjectService
  ) {
    this.project = this.projectHolder.project
  }

  ngOnInit() {
    this.projectService.getDocusignStatuses().subscribe(statuses => {
      this.statuses = statuses
      if(this.status) {
        this.tempStatus = this.status;
      }
    });
  }

  statusChange(status: ProjectStatus) {
    this.status = status
    this.projectService
    .saveProject({
      id: this.project.id,
      docuSignStatus: this.status
    })
    .subscribe(() => {
      this.tempStatus = this.status
    }, error => {
      this.status = this.tempStatus
    })
  }

}
